/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateOrderDetailsCommand } from '../../models/create-order-details-command';
import { CreateOrderDetailsCommandResult } from '../../models/create-order-details-command-result';

export interface ApiNurseryManagerOrderDetailsAddRecommendedItemPost$Params {
      body?: CreateOrderDetailsCommand
}

export function apiNurseryManagerOrderDetailsAddRecommendedItemPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrderDetailsAddRecommendedItemPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateOrderDetailsCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrderDetailsAddRecommendedItemPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateOrderDetailsCommandResult>;
    })
  );
}

apiNurseryManagerOrderDetailsAddRecommendedItemPost.PATH = '/api/NurseryManager/OrderDetails/AddRecommendedItem';
